import { devtools } from 'zustand/middleware';

export const devTools = (import.meta.env.MODE === 'development' ? devtools : (fn: unknown) => fn) as typeof devtools;
